import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconDashboard } from "@tabler/icons-react";
import { AppSupervisorDef } from "./AppSupervisorDef";

export const AppSupervisorIcon = IconDashboard;
export const AppSupervisorHelpText = '* AppSupervisor.';

export class AppSupervisor extends Entity<AppSupervisorDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new AppSupervisorDef(), parentKeys);
        this.Form = import('./AppSupervisorForm').then((module) => module.AppSupervisorForm);
        this.Title = "AppSupervisor";
        this.HelpText = AppSupervisorHelpText;
        this.Icon = AppSupervisorIcon;
    }
}